import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FEATURED_SLUGS } from '../data/experiences';
import { EXPERIENCE_PARTNERS } from '../data/experiencePartners';
import { useCatalog } from '../data/catalog';
import { Kicker, Reveal } from './Reveal';
import { MarketplaceCard } from './MarketplaceCard';
import { useLang } from '../i18n';

export const Featured = () => {
  const { t } = useLang();
  const { experienceBySlug } = useCatalog();
  const navigate = (slug) => `/experiences/${slug}`;

  return (
    <section id="experiencias" data-testid="featured-section" className="scroll-mt-20 bg-eco-cream py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Kicker>{t('nav.experiences')}</Kicker>
            <h2 className="eco-section-title mt-4 text-eco-ink">
              {t('feat.title')}
            </h2>
            <p className="eco-secondary mt-2 text-eco-ink/55">{t('feat.sub')}</p>
          </div>
          <Link
            to="/experiences"
            data-testid="featured-view-all-button"
            className="eco-btn-text group"
          >
            {t('view.all')} <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURED_SLUGS.map((slug, i) => {
            const e = experienceBySlug(slug);
            if (!e) return null;
            return (
              <Reveal key={slug} delay={(i % 3) * 0.1}>
                <MarketplaceCard
                  experience={e}
                  to={navigate(slug)}
                  testid={`featured-card-${slug}`}
                  image={e.img}
                  imageBadge={e.island}
                  eyebrow={`${e.island} · ${e.category}`}
                  title={e.name}
                  location={e.location}
                  duration={e.duration}
                  partner={`${t('detail.operator')}: ${EXPERIENCE_PARTNERS[slug] || t('detail.localop')}`}
                  cta={t('nav.explore')}
                />
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
